import styled from 'styled-components';
import { ContentContainerProps, HeaderWrapperProps } from './types';

interface CardContainerProps {
	$width?: string;
	$height?: string;
	$maxWidth?: string;
}

export const CardContainer = styled.div<CardContainerProps>`
	width: ${props => props.$width || '595px'};
  max-width: ${props => props.$maxWidth || 'calc(100vw - 20px)'};
	height: ${props => props.$height || 'initial'};

	@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
		width: 725px;
	}
`;

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
	background: white;
	border-radius: ${props => props.$isRounded ? '24px' : '24px 24px 0 0'};
	display: flex;
	align-content: center;
	height: ${props => props.$height || '40px'};
	padding: ${props => props.$padding || '16px'};
`;

export const ContentContainer = styled.div<ContentContainerProps>`
  --margins: ${props => props.$margins ? '80px' : '0'};
	@media only screen and (min-device-width: 576px) {
    margin-right: var(--margins);
    margin-left: var(--margins);
	}

	padding: ${props => props.$padding || '16px'};
`;
